import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SharedModule } from "@shared/shared.module";
import { NzModalRef } from "ng-zorro-antd/modal";
import { SharedService } from "src/app/services/shared.service";
import { MasterService } from "src/app/services/master.service";
import { catchError, finalize, of } from "rxjs";

@Component({
  selector: "app-regenerate-storyboard-shot",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule],
  templateUrl: "./regenerate-storyboard-shot.component.html",
  styleUrl: "./regenerate-storyboard-shot.component.scss",
})
export class RegenerateStoryboardShotComponent implements OnInit {
  @Input() shotId: string | number = null;
  @Input() shotDescription: string = "";
  @Output() onRegenerate = new EventEmitter<any>();

  regenerateForm!: FormGroup;
  isFormSubmitted: boolean = false;
  aiModelList: any[] = [];
  imageStyles: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private modalRef: NzModalRef,
    private sharedService: SharedService,
    private masterService: MasterService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadAIModels();
    this.fetchImageStyleList();
  }

  initForm(): void {
    this.regenerateForm = this.formBuilder.group({
      aiPrompt: [this.shotDescription || "", [Validators.required]],
      imageStyle: ["", [Validators.required]],
      aiModel: ["", [Validators.required]],
    });
  }

  loadAIModels(): void {
    this.sharedService.showSpinner();
    this.masterService
      .getAIModelList({ tool: "Storyboard" })
      .pipe(
        catchError((err) => of(null)),
        finalize(() => this.sharedService.hideSpinner())
      )
      .subscribe((response: any) => {
        if (response && response.statusCode === 200) {
          this.aiModelList = response.data?.creditstools || [];
          // Set default AI model if available
          if (
            this.aiModelList &&
            this.aiModelList.length > 0 &&
            !this.regenerateForm.get("aiModel")?.value
          ) {
            this.regenerateForm.patchValue({
              aiModel: this.aiModelList[0].model_id,
            });
          }
        }
      });
  }

  fetchImageStyleList(): void {
    this.sharedService.showSpinner();

    this.masterService
      .getImageStyleList()
      .pipe(
        catchError((err) => of(null)),
        finalize(() => this.sharedService.hideSpinner())
      )
      .subscribe((response: any) => {
        if (response && response.statusCode === 200) {
          this.imageStyles = response.data || [];
        }
      });
  }

  getControl(controlName: string): AbstractControl {
    return this.regenerateForm.controls[controlName];
  }

  onSubmit(): void {
    this.isFormSubmitted = true;
    if (this.regenerateForm.valid) {
      const formValue = this.regenerateForm.value;
      this.onRegenerate.emit({
        aiPrompt: formValue.aiPrompt,
        imageStyle: formValue.imageStyle,
        aiModel: formValue.aiModel,
      });
      this.modalRef.destroy();
    }
  }

  onCancel(): void {
    this.modalRef.destroy();
  }
}
